import {apiRTK, Tag} from 'api/api-rtk'
import type * as API from './types'

const WEBHOOKS_TAG = {id: 'List', type: Tag.Webhooks}

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		getWebhooks: create.query<API.WebhooksPageVM, void>({
			providesTags: [WEBHOOKS_TAG],
			query: () => ({
				url: 'webhooks/page'
			})
		}),

		createWebhook: create.mutation<API.Webhook, API.CreateWebhookPayload>({
			invalidatesTags: [WEBHOOKS_TAG],
			query: data => ({
				data,
				method: 'POST',
				url: 'webhooks'
			})
		}),

		updateWebhook: create.mutation<
			API.Webhook,
			{ id: string; data: API.UpdateWebhookPayload }
		>({
			invalidatesTags: (_result, _error, {id}) => [
				WEBHOOKS_TAG,
				{id, type: Tag.Webhooks}
			],
			query: ({id, data}) => ({
				data,
				method: 'PUT',
				url: `webhooks/${id}`
			})
		}),

		deleteWebhook: create.mutation<void, string>({
			invalidatesTags: [WEBHOOKS_TAG],
			query: id => ({
				method: 'DELETE',
				url: `webhooks/${id}`
			})
		}),

		testContactConnected: create.mutation<API.TestWebhookResultVM, string>({
			query: webhookId => ({
				method: 'POST',
				url: `webhooks/${webhookId}/test/contact-connected`
			})
		}),

		testInvitationSent: create.mutation<API.TestWebhookResultVM, string>({
			query: webhookId => ({
				method: 'POST',
				url: `webhooks/${webhookId}/test/invitation-sent`
			})
		}),

		testContactScrapped: create.mutation<API.TestWebhookResultVM, string>({
			query: webhookId => ({
				method: 'POST',
				url: `webhooks/${webhookId}/test/contact-scrapped`
			})
		}),

    testContactNotesChanged: create.mutation<API.TestWebhookResultVM, string>({
      query: webhookId => ({
        method: 'POST',
        url: `webhooks/${webhookId}/test/contact-notes-changed`
      })
    }),

    testContactQualificationChanged: create.mutation<API.TestWebhookResultVM, string>({
      query: webhookId => ({
        method: 'POST',
        url: `webhooks/${webhookId}/test/contact-qualification-changed`
      })
    }),

    testMessageSent: create.mutation<API.TestWebhookResultVM, string>({
      query: webhookId => ({
        method: 'POST',
        url: `webhooks/${webhookId}/test/message-sent`
      })
    }),

    testMessageReceived: create.mutation<API.TestWebhookResultVM, string>({
      query: webhookId => ({
        method: 'POST',
        url: `webhooks/${webhookId}/test/message-received`
      })
    })
  }),
	overrideExisting: true
})